import { UserStore } from '../stores/user-roles-store';
import { RoleName } from '../types/user-role-types';

export const setUserRoles = (userRoles: RoleName[]): void => {
  try {
    if (userRoles.length > 0) {
      updateRolesStore(userRoles);
    } else {
      updateRolesStore([RoleName.Admin]);
    }
  } catch {
    setReadOnlyRole();
  }
};

const updateRolesStore = (roles: RoleName[]) => {
  UserStore.roles = roles;
};

const setReadOnlyRole = () => {
  UserStore.roles = [RoleName.ReadOnly];
};
